import React, { type Ref } from 'react';

import { htmlPattern } from '@pkg/utils';

import { FieldText, type FieldTextProps } from '../FieldText';

type FieldTextSubset = Pick<
    FieldTextProps,
    | 'inputRef'
    | 'id'
    | 'name'
    | 'value'
    | 'label'
    | 'placeholder'
    | 'size'
    | 'theme'
    | 'autoFocus'
    | 'backdropBlur'
    | 'disabled'
    | 'error'
    | 'required'
    | 'onBlur'
    | 'onFocus'
    | 'onChange'
>;

export interface FieldEmailProps extends FieldTextSubset {
    wrapperRef?: Ref<HTMLDivElement>;
}

export function FieldEmail({ wrapperRef, value = '', onChange, ...rest }: FieldEmailProps) {
    // Only trigger native error styling once we cross the min-character threshold.
    const nativeErrorStyling = `${value}`.length > 6;

    return (
        <FieldText
            ref={wrapperRef}
            type="email"
            value={value}
            nativeErrorStyling={nativeErrorStyling}
            pattern={htmlPattern.email}
            onChange={onChange}
            {...rest}
        />
    );
}
